<!-- eslint-disable vue/valid-template-root -- Renderless component: it mounts modals via useModalsStore, no DOM output of its own. -->
<template></template>

<script setup lang="ts">
import { computed, inject, markRaw, watch } from 'vue'

import { SET_CURRENT_REPOSITORY } from '@/const'

import { handleCatchedError } from '@/helpers/common'

import { useModalsStore } from '@/store/modals'
import { useRepositoriesStore } from '@/store/repositories/index'
import { useRepositoriesCollaboratorsStore } from '@/store/repositories/collaborators'

import InvitesDialog from './InvitesDialog.vue'

defineOptions({ name: 'AppInvites' })

const setCurrentRepository = inject<(id?: string) => void>(
  SET_CURRENT_REPOSITORY,
)

const modalsStore = useModalsStore()
const repositoriesStore = useRepositoriesStore()
const repositoriesCollaboratorsStore = useRepositoriesCollaboratorsStore()

const hasUnanswered = computed(
  () =>
    !!repositoriesCollaboratorsStore.getInvites?.filter(
      invite => invite.accepted === undefined,
    ).length,
)

const unclosable = computed(() => hasUnanswered.value || !repositoriesStore.getCurrentId)

const handleGoToRepo = async (repositoryId?: string, callback?: () => void) => {
  if (hasUnanswered.value) return
  callback?.()
  try {
    await repositoriesStore.fetch()
    setCurrentRepository && setCurrentRepository(repositoryId)
  } catch (e) {
    handleCatchedError(e as string)
  }
}

const handleOpen = () => {
  const modalInstance = modalsStore.init(
    'invites-dialog',
    markRaw(InvitesDialog)
  )
  modalInstance?.open(modalsStore.getZIndex(), {
    unclosable,
    onGoToRepo: handleGoToRepo,
  })
}

watch(
  () => [repositoriesCollaboratorsStore.loadingInvites, hasUnanswered.value],
  ([loading, unanswered]) => {
    if (loading || !unanswered) return
    handleOpen()
  },
  {
    immediate: true,
  },
)
</script>

<style>
.app-invites {
  @apply flex-auto;
  @apply -mt-6 -mb-4;
}
</style>
